import { render, staticRenderFns } from "./AdminLog.vue?vue&type=template&id=15486870&scoped=true"
import script from "./AdminLog.vue?vue&type=script&lang=js"
export * from "./AdminLog.vue?vue&type=script&lang=js"
import style0 from "./AdminLog.vue?vue&type=style&index=0&id=15486870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15486870",
  null
  
)

export default component.exports